import { useResetAtom } from 'jotai/utils';
import React, { useCallback } from 'react';

import { useSwapDrawer } from '~/hooks/use-swap-drawer';
import { draftAppointmentPatientProfileDrawerState } from '~/state/reception/atoms';
import { DraftAppointmentPatientProfileDrawerState as DraftAppointmentPatientProfileDrawerStateType } from '~/state/reception/types';

import { FinishDraftAppointmentModal } from './FinishDraftAppointmentModal';
import { ProfileDrawer } from './ProfileDrawer';
import { RequestAppointmentModal } from './RequestAppointmentModal';

export const DraftAppointmentPatientProfileDrawer = () => {
  const {
    state: { isOpen, draftAppointmentId, patientId },
    handleTransitionEnd,
  } = useSwapDrawer<DraftAppointmentPatientProfileDrawerStateType>(
    draftAppointmentPatientProfileDrawerState,
    'draftAppointmentId',
  );

  const resetState = useResetAtom(draftAppointmentPatientProfileDrawerState);

  const handleClose = useCallback(() => {
    resetState();
  }, [resetState]);

  if (!draftAppointmentId) {
    return null;
  }

  return (
    <>
      <ProfileDrawer
        open={isOpen}
        draftAppointmentId={draftAppointmentId}
        patientId={patientId}
        onClose={handleClose}
        onTransitionEnd={handleTransitionEnd}
      />
      <RequestAppointmentModal draftAppointmentId={draftAppointmentId} />
      <FinishDraftAppointmentModal draftAppointmentId={draftAppointmentId} />
    </>
  );
};
